import RecommendedProduct from "./RecommendedProduct";
export default RecommendedProduct;
